import React, { PureComponent } from 'react'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  Container,
} from 'reactstrap'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import ScrollIntoView from 'react-scroll-into-view'
import { Link } from 'gatsby'

class MyNavbar extends PureComponent {
  state = {
    isOpen: false,
  }

  toggle = () => {
    this.setState(state => ({
      isOpen: !state.isOpen,
    }))
  }
  render() {
    const { scrolled } = this.props
    return (
      <StaticQuery
        query={graphql`
          query NavbarQuery {
            logo: file(relativePath: { eq: "TYPEMARK.png" }) {
              childImageSharp {
                fixed(width: 200) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
          }
        `}
      >
        {data => (
          <Navbar
            color={scrolled ? 'dark' : 'transparent'}
            dark
            expand="md"
            fixed="top"
          >
            <Container>
              <Link to="/" className="navbar-brand">
                <Img fixed={data.logo.childImageSharp.fixed} />
              </Link>
              <NavbarToggler onClick={this.toggle} />
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className="ml-auto" navbar>
                  <NavItem>
                    <NavLink tag="button" className="btn btn-link">
                      <ScrollIntoView selector="#what">
                        What is Supernova?
                      </ScrollIntoView>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag="button" className="btn btn-link">
                      <ScrollIntoView selector="#about">About</ScrollIntoView>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag="button" className="btn btn-link">
                      <ScrollIntoView selector="#story">Story</ScrollIntoView>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <Link to="/register" className="nav-link btn btn-link">
                      Register
                    </Link>
                  </NavItem>
                </Nav>
              </Collapse>
            </Container>
          </Navbar>
        )}
      </StaticQuery>
    )
  }
}

export default MyNavbar
